import { useTranslation as uT } from 'react-i18next';

import { type categoryGroups } from '@cx-modules/constants';

export type Namespace = NonNullable<(typeof categoryGroups)[number]['translationFile']>;

export const useTranslation = (namespaces: Namespace | Namespace[] = 'label') => {
  const namespaceArray = Array.isArray(namespaces) ? namespaces : [namespaces];
  return uT(namespaceArray);
};
